import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { FC, memo } from 'react'
import styled from 'styled-components'

import { HistoAggregationConfigView } from './aggregation/HistoAggregationConfigView'
import { HistoColorConfigView } from './HistoColorConfigView'
import { HistoPlotConfigView } from './HistoPlotConfigView'
import { HistoSortConfigView } from './HistoSortConfigView'
import { HistoStackingConfigView } from './stacking/HistoStackingConfigView'

const HistogramConfigurationPanelContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 40px;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
  flex-direction: column;
  width: 90%;
  justify-content: start;
  gap: 0.5rem;
`

const RawHistogramConfigurationPanel: FC = () => {
  const { plotType } = useHistogramConfiguration()
  return (
    <HistogramConfigurationPanelContainer>
      <HistoAggregationConfigView />
      <HistoPlotConfigView />
      <HistoSortConfigView />
      <HistoColorConfigView />
      {plotType === 'stacked' && <HistoStackingConfigView />}
    </HistogramConfigurationPanelContainer>
  )
}

export const HistogramConfigurationPanel = memo(RawHistogramConfigurationPanel)
